import { useRef } from "react";
import { uniqueId } from "lodash";

// Small helper hook to assign a fixed unique id to a component
//
export const useUniqueId = prefix => useRef(uniqueId(prefix)).current;
